export const environment = {
	production: true,
	api: {
		baseUrl: 'https://roadmapapi.cri.it/api/',
		apimanagerUrl: 'https://am.cri.it:8243/',
		config: {
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'Authorization': ''
			}
		}
	},
	gaia: {
		'url': 'https://gaia.cri.it',
		'authorizeURI': '/o/authorize/',
		'redirect_uri': 'https://roadmap.cri.it/gaia_handler',
		'client_id': 'KhXJuumzMls9IFBbvw9TJViiCXzoFl8tNcYR4QyX',
		'scope': 'anagrafica_lettura_base anagrafica_lettura_completa'
	},
	cookieDomain: 'roadmap.cri.it',
	cookie: {
		version: 2,
		rules: false,
	},
};
